import baseUrl from '@/utils/api';
import request from './http';


/*
 下载课件（打包）
 @params resultId 课件id
*/
export function getCombinePack({
  resultId,
  clientsId,
}) {
  return request({
    baseURL: baseUrl,
    url: `api/courseware/combine-pack/result/${resultId}?clients_id=${clientsId}`,
    method: 'get',
  });
}

/*
  下载课件（获取打包状态）
  @params resultId 课件id
 */
export function getCombinePackStatus({
  resultId,
  clientsId,
}) {
  return request({
    baseURL: baseUrl,
    url: `api/courseware/combine-pack/result/${resultId}/packet-status?clients_id=${clientsId}`,
    method: 'get',
  });
}

/*
  下载课件（获取课件内容）
  @params url 课件url
 */
export function getCombinePackDownload({
  url,
  clientsId,
}) {
  return request({
    baseURL: baseUrl,
    url: `api/courseware/combine-pack/download?clients_id=${clientsId}`,
    method: 'get',
    params: {
      url,
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js